import * as React from "react";

import Slider from "@mui/material/Slider";

interface i_slidervalue {
  default_value: number;
  setValue: any;
  min: number;
  max: number;
  step: number;
  value: number;
  testid: string;
}

export default function NewSlider({
  setValue,
  min,
  max,
  step,
  default_value,
  value,
  testid
}: i_slidervalue) {
  function valuetext(value: number) {
    return `${value}`;
  }
  return (
    <Slider
      defaultValue={default_value}
      getAriaValueText={valuetext}
      valueLabelDisplay="auto"
      step={step}
      marks
      min={min}
      max={max}
      value={value}
      onChange={(e: any) => {
        setValue(e.target.value);
      }}
      data-testid={testid}
    />
  );
}
